import { useEffect, useState } from 'react';
import { getMode, setMode, subscribeMode, type DashboardMode } from './mode';

/** React binding for `lib/mode.ts` - re-renders the calling component whenever the Test/Live
 * switch changes, from anywhere in the tree (not just the component that owns the switch). */
export function useMode(): [DashboardMode, (mode: DashboardMode) => void] {
  const [mode, setModeState] = useState<DashboardMode>(getMode());
  useEffect(() => subscribeMode(setModeState), []);
  return [mode, setMode];
}
